/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Badge,
  Popconfirm,
  Avatar,
  Layout,
  Table,
  Input,
} from "antd";
import { ALL_POPUP, DELETE_POPUP, IMAGE_BASE_URL } from "../../constants/api";

function PopupTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const row = data["data"];
        const index = 0;
        const formattedData = [
          {
            key: index,
            ID: index + 1,
            Link: row.link,
            Image: (
              <Badge>
                <Avatar
                  src={
                    row.image !== null
                      ? IMAGE_BASE_URL + row.image.filePath
                      : ""
                  }
                  shape="circle"
                  size="large"
                />
              </Badge>
            ),
            Action: (
              <Space>
                <Button
                  onClick={() => {
                    navigate("/popup/edit/" + row.id);
                  }}
                  block
                >
                  Edit
                </Button>
                <Popconfirm
                  title="Delete the data"
                  description="Are you sure to delete this data?"
                  onConfirm={() => deleteData(row.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              </Space>
            ),
          },
        ];
        setState(formattedData);
        setFilteredState(formattedData); // Set the initial filtered data
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(ALL_POPUP, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = { id: values };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_POPUP, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((slider) =>
      slider.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Image",
      dataIndex: "Image",
      width: 50,
    },
    {
      title: "Link",
      dataIndex: "Link",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage popup"
          extra={
            <Space>
              <Input
                placeholder="Search by Name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              {state.length === 0 ? (
                <Button onClick={() => navigate("/popup/add")}>
                  Add <PlusOutlined />
                </Button>
              ) : null}
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState} // Use filtered state
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default PopupTable;
